import AddressApi from "../../../services/api/addressApi";

const AddressApiService = new AddressApi();

export default {
  data() {
    return {
      tabLinks: [
        { name: "Profile", path: "profile", routeName: "dashboardProfile" },
        { name: "Password", path: "password", routeName: "dashboardPassword" },
        { name: "Addresses", path: "addresses", routeName: "dashboardAddresses" },
      ],
      default_shipping: null,
      default_billing: null,
      addresses: [],
    };
  },

  methods: {
    redirect,
    confirmRemove,
    remove,
    setAsDefault,
    getAll,
  },

  computed: {
    defaultShippingAddress,
    defaultBillingAddress,
    nonDefaultAddresses,
  },

  beforeMount() {
    this.getAll();
  },
};

function redirect(id) {
  if (id) {
    this.$router.push({
      name: "dashboardEditAddress",
      params: {
        id: id,
      },
    });
  } else {
    this.$router.push({
      name: "dashboardCreateAddress",
    });
  }
}

function confirmRemove(id, type) {
  const _self = this;

  _self
    .$swal({
      title: "Are you sure?",
      text: `Are you sure you want to remove this address?`,
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: "Confirm",
    })
    .then(function (confirm) {
      if (confirm.value) {
        _self.remove(id);
      }
    });
}

function remove(id) {
  this.$loader.$emit("trigger", true);

  AddressApiService.remove(id)
    .then(() => {
      this.$swal("Success", "Address successfully removed.");
      this.getAll();
    })
    .catch((error) => {
      this.$swal("Attention", error.response.data.error_message);
    })
    .finally(() => {
      this.$loader.$emit("trigger", false);
    });
}

function setAsDefault(address, type) {
  this.$loader.$emit("trigger", true);

  AddressApiService.setDefault(address.id, {
    ...address,
    [`default_${type}`]: true,
  })
    .then(() => {
      this.$swal("Success", `Successfully set default ${type.toLowerCase()} address`);
      this.getAll();
    })
    .catch((error) => {
      this.$swal("Attention", error.response.data.error_message);
    })
    .finally(() => {
      this.$loader.$emit("trigger", false);
    });
}

function getAll() {
  this.$loader.$emit("trigger", true);
  this.addresses = [];
  this.default_shipping = null;
  this.default_billing = null;

  AddressApiService.getAll()
    .then(({ data }) => {
      this.addresses = data;
    })
    .catch((error) => {
      this.$swal("Attention", error.response.data.error_message);
    })
    .finally(() => {
      this.$loader.$emit("trigger", false);
    });
}

function nonDefaultAddresses() {
  return this.addresses.filter((address) => !address.is_default_shipping && !address.is_default_billing);
}

function defaultShippingAddress() {
  return this.addresses.find((address) => address.default_shipping);
}

function defaultBillingAddress() {
  return this.addresses.find((address) => address.default_billing);
}
